<script setup lang="ts">
import { Monitor, TabletSmartphone } from 'lucide-vue-next';

import { cn } from '@/lib/utils';

import type { HTMLAttributes } from 'vue';
import type { Session } from '@/types/userSettings';

withDefaults(
  defineProps<{
    class?: HTMLAttributes['class'];
    sessionDetailsClass?: HTMLAttributes['class'];
    session: Session;
    truncate?: boolean;
    isSmall?: boolean;
    isOption?: boolean;
  }>(),
  {
    class: null,
    sessionDetailsClass: null,
    truncate: false,
    isSmall: false,
    isOption: false
  }
);
</script>

<template>
  <div
    :class="cn('flex gap-2.5', $props.class)"
    data-testid="session-info-wrapper"
    :data-id="`session-info-wrapper-${session.id}`"
  >
    <Monitor
      v-if="session.agent.isDesktop"
      data-testid="session-info-desktop"
      class="w-4 h-4 shrink-0 m-2 self-start"
    />
    <TabletSmartphone
      v-else
      data-testid="session-info-mobile"
      class="w-4 h-4 shrink-0 m-2 self-start"
    />
    <div :class="sessionDetailsClass">
      <p
        :class="
          cn(
            'text-sm font-semibold text-gray-800 break-words',
            truncate && 'truncate',
            isSmall && 'mt-0.5',
            !isOption && 'max-w-64'
          )
        "
        data-testid="session-info-device-name"
      >
        {{ `${session.agent.platform} (${session.agent.browser})` }}
      </p>
      <p
        :class="
          cn(
            'text-xs text-gray-600 break-words',
            truncate && 'truncate',
            !isSmall && 'mt-0.5',
            !isOption && 'max-w-64'
          )
        "
        data-testid="session-info-device-ip-address"
      >
        {{ session.ipAddress }}
      </p>
      <p
        :class="
          cn(
            'text-xs text-gray-600 break-words',
            truncate && 'truncate',
            !isSmall && 'mt-0.5',
            !isOption && 'max-w-64',
            session.isCurrentDevice && 'text-emerald-500'
          )
        "
        data-testid="session-info-device-last-login"
      >
        {{
          session.isCurrentDevice
            ? $t('userProfile.This device')
            : `${$t('manageAccounts.last_login')} ${session.lastActive}`
        }}
      </p>
    </div>
    <slot></slot>
  </div>
</template>
